module.exports = __webpack_public_path__ + "img/ico_write_shorts.528a4ce.svg";